export default __webpack_public_path__ + "static/media/reload.40d3d246.svg";